var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContentCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "content_copy_svg__a",
  width: 21,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.5 0h20v20H.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#content_copy_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 15.001q-.687 0-1.177-.489a1.6 1.6 0 0 1-.49-1.177v-10q0-.688.49-1.178.49-.489 1.177-.489h7.5q.687 0 1.177.49.49.489.49 1.177v10q0 .687-.49 1.177t-1.177.49zm0-1.666h7.5v-10H8zm-3.333 5q-.688 0-1.178-.49A1.6 1.6 0 0 1 3 16.669V5.835q0-.354.24-.595.24-.239.593-.239.354 0 .595.24.239.24.239.594v10.833H13q.354 0 .594.24t.24.593q0 .354-.24.594a.8.8 0 0 1-.594.24z"
}))));
export default SvgContentCopy;